import { render, staticRenderFns } from "./createWebsiteStep1.vue?vue&type=template&id=d481d04a&scoped=true"
import script from "./createWebsiteStep1.vue?vue&type=script&lang=js"
export * from "./createWebsiteStep1.vue?vue&type=script&lang=js"
import style0 from "./createWebsiteStep1.vue?vue&type=style&index=0&id=d481d04a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d481d04a",
  null
  
)

export default component.exports